export const validators = {
  required: (value) => !value || !String(value).trim() ? 'This field is required' : null,

  email: (value) => {
    if (!value) return null;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !pattern.test(value) ? 'Enter a valid email address' : null;
  },

  phone: (value) => {
    if (!value) return null;
    const cleaned = value.replace(/[\s\-()+]/g, '');
    return !/^\d+$/.test(cleaned) || cleaned.length < 7 || cleaned.length > 15
      ? 'Enter a valid phone number'
      : null;
  },

  minLength: (min) => (value) =>
    value && value.length < min ? `Must be at least ${min} characters` : null,

  maxLength: (max) => (value) =>
    value && value.length > max ? `Cannot exceed ${max} characters` : null,

  minValue: (min) => (value) =>
    value !== '' && Number(value) < min ? `Must be at least ${min}` : null,

  maxValue: (max) => (value) =>
    value !== '' && Number(value) > max ? `Cannot exceed ${max}` : null,

  positiveNumber: (value) =>
    value !== '' && Number(value) <= 0 ? 'Must be a positive number' : null,

  url: (value) => {
    if (!value) return null;
    try {
      new URL(value);
      return null;
    } catch {
      return 'Enter a valid URL (e.g., https://example.com)';
    }
  },

  zipCode: (value) => {
    if (!value) return null;
    return !/^\d{5}(-\d{4})?$/.test(String(value).trim()) ? 'Enter a valid ZIP code' : null;
  },

  password: (value) => {
    if (!value) return null;
    if (value.length < 8) return 'Password must be at least 8 characters';
    if (!/[A-Z]/.test(value)) return 'Must contain at least one uppercase letter';
    if (!/[0-9]/.test(value)) return 'Must contain at least one number';
    return null;
  },

  dateNotPast: (value) => {
    if (!value) return null;
    const d = new Date(value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return d < today ? 'Date cannot be in the past' : null;
  },

  endAfterStart: (startValue) => (endValue) => {
    if (!endValue || !startValue) return null;
    return new Date(endValue) <= new Date(startValue)
      ? 'End date must be after start date'
      : null;
  },

  fileSize: (maxMB = 25) => (file) => {
    if (!file) return null;
    return file.size > maxMB * 1024 * 1024 ? `File size cannot exceed ${maxMB}MB` : null;
  },

  fileType: (allowedTypes) => (file) => {
    if (!file) return null;
    const ext = file.name.split('.').pop().toLowerCase();
    return !allowedTypes.includes(ext) ? `Allowed types: ${allowedTypes.join(', ')}` : null;
  },
};

export const runValidators = (value, validatorList) => {
  if (!validatorList || !validatorList.length) return null;
  for (const validator of validatorList) {
    const error = validator(value);
    if (error) return error;
  }
  return null;
};
